'use strict';

const tracking = require('dibs-tracking');
const get = require('lodash.get');

const getProp = (list, prop) => {
    return list.reduce((prev, listItem) => {
        if (listItem[prop]) {
            prev.push(listItem[prop]);
        }
        return prev;
    }, []);
};

const getCategory = (categories = []) => {
    const inflatedCategories = categories.length ? categories[categories.length - 1] : false;
    return inflatedCategories ? getProp(inflatedCategories, 'label').join('/') : undefined;
};

const getItemData = (product = {}, index) => {
    const item = product.item || {};
    const { id, title: name } = item;
    return {
        name,
        id,
        category: getCategory(get(item, 'classification.inflatedCategories')),
        brand: get(item, 'seller.id'),
        price: get(item, 'pricing.totalAmount.convertedAmounts.USD'),
        position: index + 1,
        list: 'cart',
    };
};

const getProducts = function(portfolioItems) {
    return portfolioItems.map((product, index) => {
        let productJson = product;
        if (typeof product.toJSON === 'function') {
            productJson = product.toJSON();
        }
        return getItemData(productJson, index);
    });
};

module.exports = {
    trackPageView({ pageType, pageSubType }) {
        tracking.trackPageview({
            pageType,
            pageSubType,
        });
    },
    trackEcommerce: function(type, portfolioItems) {
        const obj = {
            type: type,
            products: getProducts(
                Array.isArray(portfolioItems) ? portfolioItems : [portfolioItems]
            ),
        };

        if (type === 'productClick') {
            obj.actionField = {
                list: 'cart',
            };
        }

        tracking.trackEcommerce(obj);
    },
    trackBackToShopping: function() {
        tracking.trackEvent({
            category: 'cart actions',
            action: 'back to shopping click',
        });
    },
};



// WEBPACK FOOTER //
// ./assets/js/favorites/components/cart/cartTracking.es.js